import { useState, useEffect, useMemo, useCallback } from 'react';
import '../css/Menu.css';
import handleSubMenuClick from '../function/HandleSubMenuClick';
import { countMissingFieldByPage } from '../function/CountMissingFieldByPage';
import { getTreeStructure } from '../treeStructure';
import { useNavigation } from '../function/navigation';

function Menu({ options, inputs, result, clickTriggeredRef, allPages }) {
  const { nav, dispatch } = useNavigation();
  const resolvedTreeStructure = useMemo(
    () => getTreeStructure(inputs.sv_family),
    [inputs.sv_family]
  );

  const [missingFieldByPage, setMissingFieldByPage] = useState({});

  const groups = useMemo(
    () => Object.keys(resolvedTreeStructure),
    [resolvedTreeStructure]
  );

  const visibleGroups = useMemo(
    () =>
      groups.filter((group) =>
        Object.keys(resolvedTreeStructure[group]).some((subGroup) =>
          allPages.includes(subGroup)
        )
      ),
    [groups, allPages, resolvedTreeStructure]
  );

  useEffect(() => {
    setMissingFieldByPage(
      countMissingFieldByPage(
        options,
        inputs,
        result,
        nav.showOptions,
        inputs.sv_family
      )
    );
  }, [options, inputs, result, nav.showOptions]);

  const missingFieldByGroup = useMemo(() => {
    const groupObj = {};
    for (const group of groups) {
      const subGroups = Object.keys(resolvedTreeStructure[group]);
      const total = subGroups.reduce(
        (sum, key) => sum + (missingFieldByPage[key] || 0),
        0
      );
      groupObj[group] = total;
    }
    return groupObj;
  }, [groups, missingFieldByPage]);

  const setCurrentPage = useCallback(
    (page) => dispatch({ type: 'currentPage', payload: page }),
    [dispatch]
  );

  const handleClickSubMenu = (subGroup) => {
    handleSubMenuClick(subGroup, setCurrentPage, clickTriggeredRef);
  };

  return (
    <div className="menu">
      {visibleGroups.map((group, index) => (
        <div className="menu-group" key={group}>
          <div className={`group-name-line ${index === 0 ? 'first' : ''}`}>
            <div
              className={[
                'product-menu-item',
                !nav.expandedMenu && missingFieldByGroup[group] > 0
                  ? 'warning'
                  : '',
                !nav.expandedMenu &&
                Object.keys(resolvedTreeStructure[group])
                  .filter((subGroup) => allPages.includes(subGroup))
                  .includes(nav.currentPage)
                  ? 'active'
                  : '',
              ].join(' ')}
              onClick={() => dispatch({ type: 'expandedMenu', payload: true })}
            >
              <img
                src={`${process.env.PUBLIC_URL}/icons/${group === 'Base' ? 'base' : group === 'Optimize' ? 'optimize' : 'finalise'}.png`}
                alt="optimize-icon"
                className="product-menu-icon"
              />
            </div>
            {nav.expandedMenu && <div className="group-name">{group}</div>}
          </div>
          {nav.expandedMenu && (
            <div className="expanded-menu-group">
              {Object.keys(resolvedTreeStructure[group])
                .filter((subGroup) => allPages.includes(subGroup))
                .map((subGroup) => {
                  return (
                    <div
                      key={subGroup}
                      className={`menu-item ${nav.currentPage === subGroup ? 'selected' : ''}`}
                      onClick={() => handleClickSubMenu(subGroup)}
                    >
                      <div className="menu-item-name">{subGroup}</div>
                      {missingFieldByPage[subGroup] > 0 && (
                        <div className="menu-item-missing">
                          {missingFieldByPage[subGroup]}
                        </div>
                      )}
                    </div>
                  );
                })}
            </div>
          )}
        </div>
      ))}
      <div className="menu-setting">
        <div
          className="product-menu-item"
          onClick={() =>
            dispatch({ type: 'expandedMenu', payload: !nav.expandedMenu })
          }
        >
          <img
            src={`${process.env.PUBLIC_URL}/icons/menu-toggle.png`}
            alt="menu-toggle"
            className={[
              'product-menu-icon',
              nav.expandedMenu ? 'reverse' : '',
            ].join(' ')}
          />
        </div>
      </div>
    </div>
  );
}

export default Menu;
